import { render } from "./carousel.vue?vue&type=template&id=2e82d0d8&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=2e82d0d8&scoped=true&lang=css"

import exportComponent from "/var/www/__turkey-23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e82d0d8"]])

export default __exports__